const salary_types = [
    {salaryType: 1, name: 'Monthly'},
    {salaryType: 2, name: 'Hourly'},
    {salaryType: 3, name: 'Daily'}
]

export default salary_types